const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Grid2, Link, CardMedia, Backdrop, CircularProgress } from '@mui/material';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import ContestantPopup from './ContestantPopup.jsx';
import { addHours } from 'date-fns';
import dateFormat from 'dateformat';

class ContestantImage extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = { modalopen: null };
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    componentDidMount = () => {
        this._isMounted = true;

        const get_view = this.props.view;
        const { imageProportion } = this.props.short?.allcatoption?.style ? this.props.short.allcatoption.style : 'off';

        if (imageProportion === "on" && get_view !== "topten" && get_view !== "single") {

            const post_index = this.props.indexpost;
            let image_size = "";
            if (post_index == 'null') {
                image_size = this.props.singlepost.page_cont_image != null ? this.props.singlepost.page_cont_image : this.props.singlepost.featured_image_url;
            }
            else {
                const isMobile = this.mobileCheck();
                if (isMobile) {
                    image_size = this.props.singlepost.short_cont_image_mobile != null ? this.props.singlepost.short_cont_image_mobile : this.props.singlepost.featured_image_large_url;
                } else {
                    image_size = this.props.singlepost.short_cont_image != null ? this.props.singlepost.short_cont_image : this.props.singlepost.featured_image_url;
                }
            }

            const showallpage = this.props?.showallpage ? 1 : 0;
            this.getImageDimensions(image_size, showallpage);

        }
    }
    calculateVoteTimeLeft(start_time, pause_voting_hours = 0) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time != null) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference = addHours(new Date(start_Date), pause_voting_hours) - current_date;
            return difference;
        } else {
            return -1;
        }
    }

    handlepopup = () => {
        this.setState({ modalopen: 1 });
    }

    handleClose = (event) => {
        this.setState({ modalopen: 0 });
    }

    getImageDimensions = (url, showallpage) => {
        var img = new Image();
        img.src = url;
        img.onload = () => {
            if (this._isMounted) {
                this.setState({ imgWidth: showallpage !== 1 ? img.width : '100%', imgHeight: img.height, imgPadding: 0 });
            }
        };
    }

    mobileCheck = () => {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    render() {

        let design = (this.props.view == 'grid') ? 'row' : 'column';
        const post_index = this.props.indexpost;
        const allprops = this.props;
        let tax_hide_photos = null;
        let vote_start_time = null;
        let vote_end_time = null;
        let hide_photos = 0;
        const get_view = this.props.view;
        let popup_enabled = null;
        let link_enabled = null;
        let pagin_val_prop = null;
        const shortcode = (typeof this.props.short !== "undefined") ? this.props.short.allcatoption : null;
        switch (get_view) {
            case 'grid':
                popup_enabled = allprops.settings.common.vote_prettyphoto_disable;
                link_enabled = allprops.settings.common.vote_disable_single;
                design = 'row';
                break;
            case 'list':
                popup_enabled = allprops.settings.common.vote_prettyphoto_disable;
                link_enabled = allprops.settings.common.vote_disable_single;
                design = 'column';
                break;
            case 'single':
                popup_enabled = allprops.settings.common.vote_prettyphoto_disable_single;
                design = 'row';
                break;
            case 'topten':
                popup_enabled = 'on';
                link_enabled = allprops.settings.common.vote_disable_single;
                design = 'row';
                break;
        }

        if (link_enabled == null) {
            link_enabled = 'off';
        }


        const { votes_cont_title_color_grid, votes_cont_title_color } = this.props.settings.color;

        const font_colr = (this.props.view == 'grid') ? votes_cont_title_color_grid : votes_cont_title_color;

        if (typeof allprops.short.allcatoption !== "undefined") {
            tax_hide_photos = allprops.short.allcatoption.tax_hide_photos_live;
            if (allprops?.short?.allcatoption?.votes_starttime) {
                vote_start_time = this.calculateVoteTimeLeft(allprops.short.allcatoption.votes_starttime, allprops.short.allcatoption.pause_voting);
            }
            if (allprops?.short?.allcatoption?.votes_expiration) {
                vote_end_time = this.calculateVoteTimeLeft(allprops.short.allcatoption.votes_expiration);
            }

            if (tax_hide_photos != 'on') {
                hide_photos = '1';
            }
            if (allprops.short.thumb == '0') {
                hide_photos = '0';
            }
            if (vote_start_time < 0) {
                hide_photos = '1';
            }

            pagin_val_prop = (typeof allprops.post.pagin_val !== "undefined") ? allprops.post.pagin_val : null;

            if (get_view === 'single') {
                pagin_val_prop = allprops.post_single.contestant_count;
            }

            if (tax_hide_photos === 'on') {
                if (vote_start_time == null && vote_end_time == null)
                    hide_photos = '1';

                if (vote_start_time == null && vote_end_time > 0)
                    hide_photos = '1';

                if (pagin_val_prop != null) {
                    let total_posts = get_view === 'single' ? pagin_val_prop : pagin_val_prop.total_posts;
                    let tax_activationcount = allprops.short.allcatoption.tax_activationcount;
                    if (tax_activationcount !== null && tax_activationcount !== 0 && tax_activationcount !== undefined && tax_activationcount !== "") {
                        if (parseInt(tax_activationcount) <= parseInt(total_posts)) {
                            hide_photos = '1';
                        }
                        else {
                            hide_photos = '0';
                            if (vote_start_time == null && vote_end_time > 0)
                                hide_photos = '1';
                        }
                        if (vote_start_time == null && vote_end_time == null)
                            hide_photos = '1';
                    }
                }

                if (vote_start_time < 0 && vote_end_time > 0)
                    hide_photos = '1';

            }
        }
        //Check voting button
        let time_to_vote = null;
        let timer = null;
        if (shortcode != null) {
            if (shortcode.votes_starttime != null && shortcode.votes_starttime != "") {
                timer = this.calculateVoteTimeLeft(shortcode.votes_starttime, shortcode.pause_voting);
                if (timer > 0) {
                    time_to_vote = "not_started";
                }
            }
            if (pagin_val_prop != null) {
                let total_posts = get_view === 'single' ? pagin_val_prop : pagin_val_prop.total_posts;
                let tax_activationcount = allprops.short.allcatoption.tax_activationcount || 0;
                if (tax_activationcount !== 0) {
                    if (parseInt(tax_activationcount) <= parseInt(total_posts)) {
                        time_to_vote = null;
                    }
                }
            }
            if (shortcode.votes_expiration != null && shortcode.votes_expiration != "") {
                timer = this.calculateVoteTimeLeft(shortcode.votes_expiration);
                if (timer < 0) {
                    time_to_vote = "ended";
                    hide_photos = '1';
                }
            }
        }
        //override for all contestant shortcode
        if (this.props.all_contest == 1) {
            hide_photos = '1';
            popup_enabled = 'on';
        }
        //Shortcode attribute will override all conditions
        if (allprops.short.thumb == '1') {
            hide_photos = '1';
        }
        if (this.props.singlepost) {

            let image_size = "";
            let single_page_cont_image = "";
            let single_page_cont_image_px = "";
            if (post_index == 'null') {
                image_size = this.props.singlepost.page_cont_image != null ? this.props.singlepost.page_cont_image : this.props.singlepost.featured_image_url;
                single_page_cont_image = allprops.settings.common.single_page_cont_image != null ? allprops.settings.common.single_page_cont_image : '100';
                single_page_cont_image_px = allprops.settings.common.single_page_cont_image_px != null ? allprops.settings.common.single_page_cont_image_px : '%';
            }
            else {
                const isMobile = this.mobileCheck();
                if (isMobile) {
                    image_size = this.props.singlepost.short_cont_image_mobile != null ? this.props.singlepost.short_cont_image_mobile : this.props.singlepost.featured_image_large_url;
                } else {
                    image_size = this.props.singlepost.short_cont_image != null ? this.props.singlepost.short_cont_image : this.props.singlepost.featured_image_url;
                }
            }

            return (
                <div className="wpvc_contestantimage">
                    {hide_photos != 0 &&
                        <Grid2 >
                            {popup_enabled == 'off' &&
                                <Link href={undefined} onClick={() => this.handlepopup()} className="wpvc_image_popup_modal">
                                    {
                                        post_index == 'null' &&
                                        <img
                                            className={"wpvc_image_popup_hover"}
                                            style={{ 'width': single_page_cont_image + single_page_cont_image_px }} src={image_size}
                                            title={this.props.singlepost.post_title}
                                        />
                                    }

                                    {
                                        post_index != 'null' &&
                                        <CardMedia
                                            style={{ width: this.state.imgWidth, height: this.state.imgHeight, padding: this.state.imgPadding }}
                                            className={"wpvc_image_popup_hover wpvc_card_media_" + design}
                                            image={image_size} title={this.props.singlepost.post_title}
                                        />
                                    }
                                    <AspectRatioIcon className="wpvc_icon_image_popup" style={{ 'color': font_colr }} />
                                </Link>
                            }
                            {popup_enabled == 'on' && link_enabled == 'off' &&
                                <Link href={this.props.singlepost.link}>
                                    {
                                        post_index == 'null' &&
                                        <img
                                            style={{ 'width': single_page_cont_image + single_page_cont_image_px }} src={image_size}
                                            title={this.props.singlepost.post_title}
                                        />
                                    }
                                    {
                                        post_index != 'null' &&
                                        <CardMedia
                                            style={{ width: this.state.imgWidth, height: this.state.imgHeight, padding: this.state.imgPadding }}
                                            className={"wpvc_card_media_" + design}
                                            image={image_size}
                                            title={this.props.singlepost.post_title}
                                        />
                                    }
                                </Link>
                            }
                            {popup_enabled == 'on' && link_enabled == 'on' && post_index != 'null' &&
                                <CardMedia
                                    style={{ width: this.state.imgWidth, height: this.state.imgHeight, padding: this.state.imgPadding }}
                                    className={"wpvc_card_media_" + design}
                                    image={image_size}
                                    title={this.props.singlepost.post_title}
                                />
                            }
                            {popup_enabled == 'on' && link_enabled == 'on' && post_index == 'null' &&
                                <img
                                    className={"wpvc_image_popup_hover"}
                                    style={{ 'width': single_page_cont_image + single_page_cont_image_px }} src={image_size}
                                    title={this.props.singlepost.post_title}
                                />
                            }
                        </Grid2>
                    }
                    <ContestantPopup {...allprops}
                        post={this.props.singlepost}
                        open_val={this.state.modalopen == 1 ? true : false}
                        handlemodal={this.handleClose}
                        post_index_val={post_index}
                        currentdate={this.props.currentdate}
                        vote_time={time_to_vote}
                        setButtonText={this.props.setButtonText}
                        butn_msg={this.props.butn_msg}
                    />
                </div>

            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default connect()(withTranslation("translations")(ContestantImage));
